import { useState } from "react";
import { useDidMount } from "xa-generics";
import { useTranslation } from "react-i18next";
import "./Less/RenewalNotice.css";

export const NEW_TRACKING_URL: string = "https://tracking.onemin.hu";

export interface IRenewalNoticeProps {}

const RenewalNotice: React.FC<IRenewalNoticeProps> = (props): React.ReactElement | null => {
    const [isClosed, setIsClosed] = useState<boolean>(false);

    const { t } = useTranslation();

    const close = (): void => setIsClosed(true);

    const onKeyDown = (e: KeyboardEvent): void => {
        if (e.key === "Escape") close();
    };

    const onEscKeyDown = (): (() => void) => {
        document.addEventListener("keydown", onKeyDown);
        return () => {
            document.removeEventListener("keydown", onKeyDown);
        };
    };
    useDidMount(onEscKeyDown);

    if (isClosed) return null;

    return (
        <div className="renewal-notice" onClick={close}>
            <div className="renewal-notice__card" onClick={(e) => e.stopPropagation()}>
                <div className="renewal-notice__header">
                    <div
                        className="renewal-notice__header--close"
                        title={`${t("renewal_close")}`}
                        onClick={close}
                    >
                        &times;
                    </div>
                    <div className="renewal-notice__header--badge">{t("renewal_badge")}</div>
                    <div className="renewal-notice__header--title">{t("renewal_title")}</div>
                </div>

                <div className="renewal-notice__body">
                    <div className="renewal-notice__body--text">{t("renewal_text")}</div>
                    <div className="renewal-notice__body--warning">{t("renewal_warning")}</div>

                    <a
                        className="renewal-notice__body--cta"
                        href={NEW_TRACKING_URL}
                        rel="noreferrer noopener"
                        target="_blank"
                    >
                        <span className="renewal-notice__body--cta-label">{t("renewal_cta")}</span>
                        <span className="renewal-notice__body--cta-url">tracking.onemin.hu</span>
                    </a>

                    <div className="renewal-notice__body--later" onClick={close}>
                        {t("renewal_later")}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RenewalNotice;
